import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

type Func = <T extends string | number>(p: T | undefined) => void;

@Injectable()
export class LicenseRebootstrapService {
  private formGroup: FormGroup;

  get group() {
    return this.formGroup;
  }

  constructor(private readonly fb: FormBuilder) {}

  init(cb: Func) {
    this.formGroup = this.fb.group({
      header: 'Re-bootstrap licenses',
      actionButtons: this.fb.array([
        this.fb.group({
          title: 'Re-bootstrap',
          isDisabled: false,
          class: 'btn btn-primary',
          click: cb,
          actionOK: this.fb.group({
            text:
              'License re-bootstrap started. It can take up to a few minutes.',
            enabled: false,
          }),
          actionFAIL: this.fb.group({
            text: 'Could not re-bootstrap licenses',
            enabled: false,
          }),
        }),
      ]),
      data: this.fb.group({
        default: this.fb.group({
          descriptions: [
            [
              'Re-bootstrap all enabled licenses for all sections on the account. This process can take up to a few minutes depending on the section count. Progress, success and errors are not reported here.',
            ],
          ],
        }),
      }),
    });
  }

  rebootstrapLicensesInProgress(inProgress: boolean | undefined) {
    const actionButtons = this.formGroup.get('actionButtons') as FormArray;
    actionButtons.controls[0].patchValue({
      isDisabled: inProgress,
      actionOK: { enabled: inProgress },
    });
  }

  rebootstrapLicensesTimeoutFailed(isFailed: boolean | undefined) {
    const actionButtons = this.formGroup.get('actionButtons') as FormArray;
    actionButtons.controls[0].patchValue({
      actionFAIL: { enabled: isFailed },
    });
  }
}
